"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = exports.InputPropTypes = exports.InputDefaultProps = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _inputModule = _interopRequireDefault(require("./input.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InputDefaultProps = {
  value: "",
  size: "md",
  type: "text",
  focus: false,
  placeholder: "",
  wrapper: "input",
  paddingLeft: null,
  paddingRight: null,
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onInput: function onInput() {},
  onChange: function onChange() {}
};
exports.InputDefaultProps = InputDefaultProps;
var InputPropTypes = {
  value: _propTypes.default.string,
  name: _propTypes.default.string,
  size: _propTypes.default.oneOf(["sm", "md", "lg"]),
  paddingLeft: _propTypes.default.string,
  paddingRight: _propTypes.default.string,
  type: _propTypes.default.string,
  focus: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onInput: _propTypes.default.func,
  onChange: _propTypes.default.func
};
exports.InputPropTypes = InputPropTypes;
var Input = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var Wrapper = _ref.wrapper,
      value = _ref.value,
      size = _ref.size,
      type = _ref.type,
      focus = _ref.focus,
      paddingLeft = _ref.paddingLeft,
      paddingRight = _ref.paddingRight,
      placeholder = _ref.placeholder,
      onInput = _ref.onInput,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      props = _objectWithoutProperties(_ref, ["wrapper", "value", "size", "type", "focus", "paddingLeft", "paddingRight", "placeholder", "onInput", "onChange", "onBlur", "onFocus"]);

  var _useState = (0, _react.useState)(value),
      _useState2 = _slicedToArray(_useState, 2),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  var inputRef = (0, _react.useRef)(null);
  var wrapperClassName = (0, _react.useMemo)(function () {
    return [_inputModule.default.wrapper, _inputModule.default[size]].join(" ");
  }, [size]);
  var wrapperStyle = (0, _react.useMemo)(function () {
    return {
      paddingLeft: paddingLeft,
      paddingRight: paddingRight
    };
  }, [paddingLeft, paddingRight]);
  var inputHandler = (0, _react.useCallback)(function (_ref2) {
    var value = _ref2.target.value;
    setCurrentValue(value);
    onInput(value);
  }, [onInput]);
  var changeHandler = (0, _react.useCallback)(function (_ref3) {
    var value = _ref3.target.value;
    setCurrentValue(value);
    onChange(value);
  }, [onChange]);
  (0, _react.useImperativeHandle)(ref, function () {
    return inputRef.current;
  });
  (0, _react.useEffect)(function () {
    if (focus) {
      inputRef.current.focus();
    }
  }, [focus]);
  (0, _react.useEffect)(function () {
    setCurrentValue(value);
  }, [value]);
  return /*#__PURE__*/_react.default.createElement(Wrapper, _extends({
    type: type,
    ref: inputRef,
    value: currentValue,
    onBlur: onBlur,
    onFocus: onFocus,
    onInput: inputHandler,
    onChange: changeHandler,
    placeholder: placeholder,
    style: wrapperStyle,
    className: wrapperClassName
  }, props));
});
exports.Input = Input;
Input.defaultProps = _objectSpread({}, InputDefaultProps);
Input.propTypes = _objectSpread({}, InputPropTypes);